module.exports = __webpack_public_path__ + "img/ico-pdf.cae68df8.svg";